import { Component, Input, TemplateRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-card',
  imports: [MatCardModule, MatButtonModule, NgTemplateOutlet, MatDividerModule, NgClass,CommonModule],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
  standalone: true
})
export class CardComponent {
  @Input() templateRefHeader!: TemplateRef<any>;
  @Input() templateRefContent!: TemplateRef<any>;
  @Input() templateRefFooter!: TemplateRef<any>;
  @Input() tittle!:string;
}
